import axios from 'axios';

// Dedicated axios instance for the Financial Analysis module (/api/financial).
const financialApi = axios.create({ baseURL: '/api/financial', withCredentials: true });

financialApi.interceptors.request.use(cfg => {
  const token = localStorage.getItem('flowup_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});
financialApi.interceptors.response.use(res => res.data, err => Promise.reject(err.response?.data || { error: 'Request failed' }));

export default financialApi;
